import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrl: './landing.component.scss',
    standalone: false
})
export class LandingComponent implements OnInit {
  constructor(private route: ActivatedRoute,) { }

  utm_source: string = '';

  ngOnInit() {

    this.utm_source = this.route.snapshot.queryParamMap.get('utm_source') || sessionStorage.getItem('utm_source') || '';
    sessionStorage.setItem('utm_source', this.utm_source);
  }

}
